import { render, staticRenderFns } from "./PreSupportPrediction.vue?vue&type=template&id=b6401158&scoped=true"
import script from "./PreSupportPrediction.vue?vue&type=script&lang=ts"
export * from "./PreSupportPrediction.vue?vue&type=script&lang=ts"
import style0 from "./PreSupportPrediction.vue?vue&type=style&index=0&id=b6401158&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6401158",
  null
  
)

export default component.exports